var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCbts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 79.3 48.2",
    style: {
      enableBackground: "new 0 0 79.3 48.2"
    },
    xmlSpace: "preserve",
    height: 1000,
    width: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CBTS_logo_twocolor_reverse",
    transform: "translate(456.161 226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000037680209297982705960000015452893422731664520_",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    className: "st0",
    d: "M-445-195.8c3.9,0,7.6-2.1,9.6-5.5l-4.7-2.7c-0.9,1.8-2.8,2.9-4.9,2.8 c-3.1,0.1-5.6-2.3-5.7-5.4c0-0.1,0-0.2,0-0.4c-0.1-3.1,2.2-5.6,5.3-5.8c0.1,0,0.3,0,0.4,0c2-0.1,3.9,1,4.8,2.8l4.7-2.8 c-1.9-3.4-5.6-5.5-9.5-5.4c-6-0.1-11,4.6-11.2,10.7c0,0.2,0,0.3,0,0.5c-0.1,6,4.6,11,10.7,11.2 C-445.3-195.8-445.2-195.8-445-195.8 M-421.2-218.1c-2.6-0.1-5.2,1-6.9,3.1v-11h-5.5v29.6h5.5v-2.5c1.6,2.1,4.2,3.2,6.8,3.1 c5.7,0,10.3-4.9,10.3-11.2C-410.8-213.3-415.5-218.1-421.2-218.1 M-422.2-201c-3.1,0.1-5.7-2.4-5.8-5.5c0-0.2,0-0.3,0-0.5 c-0.2-3.1,2.3-5.8,5.4-6c0.1,0,0.3,0,0.4,0c3.2-0.1,5.8,2.4,5.9,5.6c0,0.1,0,0.3,0,0.4c0.1,3.1-2.3,5.8-5.4,6 C-421.9-201-422-201-422.2-201 M-396.2-212.3v-5.2h-4.8v-5.9l-5.4,1.6v4.3h-3.7v5.2h3.7v8.8c0,5.7,2.6,7.9,10.2,7.1v-4.9 c-3.1,0.2-4.8,0.1-4.8-2.2v-8.8H-396.2z M-387.8-211.5c0-1.1,1.1-1.7,2.5-1.7c1.5,0,2.8,0.8,3.4,2.2l4.6-2.5 c-1.6-2.9-4.7-4.6-8-4.5c-4.3,0-8,2.4-8,6.7c0,7.4,10.9,5.8,10.9,8.8c0,1.2-1.2,1.8-2.9,1.8c-1.8,0.1-3.6-1-4.1-2.7l-4.7,2.7 c1.5,3.3,4.6,5,8.9,5c4.5,0,8.5-2.2,8.5-6.8C-376.9-210.4-387.8-208.4-387.8-211.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    className: "st0",
    d: "M-451.8-177.8c2.4,0,4.3-1.9,4.3-4.3c0-2.4-1.9-4.3-4.3-4.3c-2.4,0-4.3,1.9-4.3,4.3 C-456.2-179.7-454.2-177.8-451.8-177.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    className: "st0",
    d: "M-428.3-177.8c2.4,0,4.3-1.9,4.3-4.3c0-2.4-1.9-4.3-4.3-4.3c-2.4,0-4.3,1.9-4.3,4.3 C-432.6-179.7-430.7-177.8-428.3-177.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    className: "st0",
    d: "M-404.8-177.8c2.4,0,4.3-1.9,4.3-4.3c0-2.4-1.9-4.3-4.3-4.3c-2.4,0-4.3,1.9-4.3,4.3l0,0 C-409.1-179.7-407.1-177.8-404.8-177.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    className: "st0",
    d: "M-381.2-177.8c2.4,0,4.3-1.9,4.3-4.3s-1.9-4.3-4.3-4.3c-2.4,0-4.3,1.9-4.3,4.3l0,0 C-385.5-179.7-383.6-177.8-381.2-177.8L-381.2-177.8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbts);
export default __webpack_public_path__ + "static/media/cbts.2d409d1d380739caa8928d278355f7d7.svg";
export { ForwardRef as ReactComponent };